import React from 'react';
import { CssBaseline, Box, Container, Grid } from '@mui/material';
import Banner from '../Layout/Banner';
import IntroduceSection from './IntroduceSection';

function Gioithieu() {
  const url = `${process.env.REACT_APP_STATIC_URL}/uploads/banner/banner_gioithieu.png`;
    const title = 'VỀ CHÚNG TÔI'
  return (
    <Box>
      <CssBaseline />
      <Banner url={url} title={title}/>
      <IntroduceSection></IntroduceSection>
    </Box>
  );
}

export default Gioithieu;